import { CompanyTrendsSearchParams } from '~/contexts/types/company-trends/searchParams';

export const useConstants = () => {
  const defaultFromToRange = { from: '', to: '' };
  const defaultValues: CompanyTrendsSearchParams = {
    company: {
      name: '',
      license: '',
      license_area: [],
      type: [],
      strict: false,
      address: {
        state: '',
        city: '',
        zip: '',
        county: '',
      },
    },
    period: 14,
    trend: {
      state: '',
      lo_gain: {
        loan_volume: defaultFromToRange,
        headcount: defaultFromToRange,
        quantity: defaultFromToRange,
      },
      lo_loss: {
        loan_volume: defaultFromToRange,
        headcount: defaultFromToRange,
        quantity: defaultFromToRange,
      },
      lo_growth: {
        percentage: defaultFromToRange,
      },
      proj_growth: {
        loan_volume: defaultFromToRange,
      },
    },
  };

  return {
    defaultValues,
  };
};
